import { ISession } from '@users/session/vo/Session';
import { IUser } from '@users/user/vo/User';

export class InitSessionState {
  ssid?: string = '';

  initialized: boolean = false;

// @ts-ignore TODO: FIN-32798 strictNullChecks
  currentSession?: ISession = null;

// @ts-ignore TODO: FIN-32798 strictNullChecks
  currentUser?: IUser = null;
}
